export default __webpack_public_path__ + "static/media/Energy Science _ Technology.afde65be.pdf";